import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getROItemEdit = get('reservation.routes.ROItem.edit');

export const getROItemEditData = createSelector(getROItemEdit, get('data'));

export const getIsFetching = createSelector(getROItemEdit, get('fetching'));

export const getIsFetched = createSelector(getROItemEdit, get('fetched'));

export const getIsSaving = createSelector(getROItemEdit, get('saving'));

export const getIsSaved = createSelector(getROItemEdit, get('saved'));

export const getROItemPicklistCount = createSelector(
  getROItemEdit,
  get('itemPicklistCount')
);

export const getIsFetchingItemPicklistCount = createSelector(
  getROItemEdit,
  get('isFetchingItemPicklistCount')
);

export const getIsFetchedItemPicklistCount = createSelector(
  getROItemEdit,
  get('isFetchedItemPicklistCount')
);
